import { ImgHTMLAttributes, RefObject } from 'react';

import { Styles, css } from '@flipster/styled-system/css';

import { BreakpointConditions, mediaQueryMapper } from '../misc/browser/media';

type PictureSrc = { base: string } & { [K in Exclude<BreakpointConditions, 'base'>]?: string | null };

interface Props<T extends PictureSrc = PictureSrc> extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'className'
> {
  src: T;
  alt: string;
  css?: Styles;
  ref?: RefObject<HTMLImageElement | null>;
}

export const Picture = <T extends PictureSrc = PictureSrc>({ src, alt, css: cssProps, ...imgProps }: Props<T>) => {
  const sources = Object.entries(src).map(([condition, srcSet]) => ({
    media: mediaQueryMapper[condition as Exclude<BreakpointConditions, 'base'>],
    srcSet,
  }));

  return (
    <picture>
      {sources.map(({ media, srcSet }) => {
        if (!media || !srcSet) return null;
        return <source media={media} srcSet={srcSet} key={srcSet} />;
      })}
      <img src={src.base} alt={alt} {...imgProps} className={css({ display: 'block' }, cssProps)} />
    </picture>
  );
};
